import { stopPageProductText } from './page-product-text'
import { queryChargingStatistics } from '@/api/charging-statistics'
import { createRequestCancellation } from '@/api/http'
import { chartHost, stopDeviceChart } from './device-chart-runtime'
import { stopDeviceValue } from './device-value-runtime'
import { sharedReadOptions } from './shared-view'
import { CHARGING_RENDERERS, chargingParameter, chargingProduct, chargingDisplay, chargingPlaceholder, chargingCategoryVisibility, chargingCategoryDisplay, chargingPeriod, CHARGING_PERIOD_METRICS } from './charging-statistics-model'
import { createChargingStatisticsFeed } from './charging-statistics-feed'

const states = new WeakMap(), feeds = new WeakMap()
const kindOf = vm => (vm.$options.name || '').replace(/^avue-echart-/, '')
const own = vm => CHARGING_RENDERERS.includes(kindOf(vm))
const hostKey = vm => { const host = chartHost(vm), parameter = { ...vm.parameter }; delete parameter.statisticsPeriod; return JSON.stringify([vm.dataType, parameter, vm.data, host.navigationContext, host.activePageId, host.generation, !!host.menuFlag, !!host.isPreview, !!host.isSharedView, !!host.isSharedDataView, !!host.isComponentTemplateEditing]) }
const presentationKey = vm => JSON.stringify([
  vm.parameter && CHARGING_PERIOD_METRICS.includes(vm.parameter.statisticsMetric) ? chargingPeriod(vm.parameter) : '',
  ['bar', 'pie'].includes(kindOf(vm)) ? chargingCategoryVisibility(vm.parameter, vm.option) : null
])
function render (vm, data, reset = false) {
  vm.dataChart = data
  if (vm.myChart) { if (reset && vm.myChart.clear) vm.myChart.clear(); vm.updateChart(); vm.myChart.off('click'); if (vm.bindClick) vm.bindClick() }
}
function label (vm, value, error = '') {
  if (!vm.$el || !vm.$el.setAttribute) return
  const state = states.get(vm)
  if (state && !state.attributes) state.attributes = Object.fromEntries(['aria-label', 'title', 'data-charging-statistics-error'].map(key => [key, vm.$el.getAttribute ? vm.$el.getAttribute(key) : null]))
  vm.$el.setAttribute('aria-label', kindOf(vm) === 'text' && vm.dataChart ? value + '，' + vm.dataChart.value : value)
  if (error) vm.$el.setAttribute('title', error)
  else if (state && state.attributes) { if (state.attributes.title === null) vm.$el.removeAttribute('title'); else vm.$el.setAttribute('title', state.attributes.title) }
  if (error) vm.$el.setAttribute('data-charging-statistics-error', error)
  else vm.$el.removeAttribute('data-charging-statistics-error')
}
export function stopChargingStatistics (vm) {
  const state = states.get(vm)
  if (!state) return
  state.closed = true
  if (state.unsubscribe) state.unsubscribe()
  if (state.feed && state.feed.size === 0) { state.feed.dispose(); state.pool.delete(state.key) }
  if (state.timer) clearTimeout(state.timer)
  if (state.attributes && vm.$el) Object.entries(state.attributes).forEach(([key, value]) => { if (value === null) vm.$el.removeAttribute(key); else vm.$el.setAttribute(key, value) })
  states.delete(vm)
}
export function updateChargingStatistics (vm, force = false) {
  const existing = states.get(vm), binding = hostKey(vm)
  if (existing && !existing.closed && existing.binding === binding) { if (force && existing.feed) return existing.feed.refresh(); if (existing.paint) existing.paint(); else if (vm.myChart) vm.updateChart(); return }
  stopChargingStatistics(vm); clearInterval(vm.checkChart)
  const host = chartHost(vm), kind = kindOf(vm), state = { closed: false, binding }
  if (['line', 'bar'].includes(kind)) stopDeviceChart(vm)
  if (kind === 'text') { stopDeviceValue(vm); stopPageProductText(vm) }
  if (vm.sub && typeof vm.sub.unsubscribe === 'function') { try { vm.sub.unsubscribe() } catch (_) { /* 清理已断开的旧订阅 */ } vm.sub = null }
  states.set(vm, state)
  render(vm, chargingPlaceholder(kind), true)
  if (!vm.$el) { states.delete(vm); return }
  try {
    const parameter = chargingParameter(vm.parameter, kind)
    if (parameter.statisticsSource === 'demo' || host.isComponentTemplateEditing || host.isTemplatePreview || host.isTemplateEditing || host.obj && host.obj.templatePreview) {
      const demo = vm.data === undefined ? chargingPlaceholder(kind) : vm.data
      const value = kind === 'progress' && demo && Object.prototype.hasOwnProperty.call(demo, 'data') ? demo.data : demo && demo.value
      state.paint = () => {
        let data = ['text', 'progress'].includes(kind) ? chargingDisplay({ summary: { [parameter.statisticsMetric]: value } }, parameter, kind) : JSON.parse(JSON.stringify(demo))
        data = chargingCategoryDisplay(data, parameter, vm.option)
        render(vm, data); label(vm, '充电统计 · 静态演示数据')
      }
      state.paint(); return
    }
    const product = chargingProduct(parameter, host.navigationContext || {}, !!host.menuFlag && !host.isPreview)
    if (!product) { label(vm, '充电统计 · 等待当前页面产品'); return }
    let pool = feeds.get(host)
    if (!pool) { pool = new Map(); feeds.set(host, pool) }
    const key = JSON.stringify([product, host.activePageId || '', host.generation || 0])
    if (!pool.has(key)) pool.set(key, createChargingStatisticsFeed({ request: () => {
      const cancellation = createRequestCancellation()
      const index = vm.index === undefined || vm.index === null ? vm.$attrs && vm.$attrs.index : vm.index
      const componentId = index === undefined || index === null ? '' : String(index)
      const ids = host.activePageId && componentId ? { pageId: host.activePageId, componentId: String(componentId) } : {}
      return { cancel: () => cancellation.cancel('统计页面或身份已变化'), promise: queryChargingStatistics(product, sharedReadOptions(host, { cancelToken: cancellation.token, ...ids })).then(response => {
        const data = response.data || response
        const snapshot = data.result || data
        if (snapshot.kind !== 'charging-statistics' || snapshot.productId !== product || !snapshot.summary || !snapshot.charts) throw new Error('充电统计返回格式无效')
        return snapshot
      }) }
    } }))
    Object.assign(state, { pool, key, feed: pool.get(key) })
    label(vm, '充电统计 · 正在读取')
    state.paint = () => {
      if (state.closed || vm._isDestroyed || Number(vm.dataType) !== 6 || binding !== hostKey(vm)) return
      const result = state.result
      if (!result) return
      if (result.status === 'ready') {
        try { render(vm, chargingDisplay(result.snapshot, chargingParameter(vm.parameter, kind), kind, vm.option)); label(vm, result.snapshot.coverage && result.snapshot.coverage.completeToday ? '充电统计 · 平台数据' : '充电统计 · 平台观测数据，采集覆盖可能不完整') }
        catch (error) { render(vm, chargingPlaceholder(kind), true); label(vm, error.message, error.message) }
      } else { render(vm, chargingPlaceholder(kind), true); const message = result.error && result.error.message || '充电统计读取失败'; label(vm, message, message) }
    }
    state.unsubscribe = state.feed.subscribe(result => { state.result = result; state.paint() })
  } catch (error) { label(vm, error.message, error.message) }
}
export function installChargingStatisticsRuntime (Vue) {
  if (Vue.__chargingStatisticsRuntime) return
  Vue.__chargingStatisticsRuntime = true
  Vue.mixin({
    beforeCreate () {
      if (!own(this) || !this.$options.methods || !this.$options.methods.updateData) return
      const original = this.$options.methods.updateData
      this.$options.methods = { ...this.$options.methods, updateData (...args) {
        if (Number(this.dataType) === 6) return updateChargingStatistics(this, args[0] && args[0].refreshCharging === true)
        stopChargingStatistics(this); return original.apply(this, args)
      } }
    },
    created () {
      if (!own(this)) return
      this.$watch(() => hostKey(this), () => { if (Number(this.dataType) === 6) updateChargingStatistics(this); else stopChargingStatistics(this) })
      // 显隐和今日/昨日切换使用已收到的快照重绘，不能重新订阅或重查同一产品。
      this.$watch(() => presentationKey(this), () => { if (Number(this.dataType) === 6) updateChargingStatistics(this) })
    },
    mounted () {
      if (!own(this) || Number(this.dataType) !== 6) return
      // 全局 mounted 先于旧 Avue 的图表初始化；同步演示数据需等实例创建后再绘制。
      this.$nextTick(() => { if (!this._isDestroyed && Number(this.dataType) === 6) updateChargingStatistics(this) })
    },
    beforeDestroy () { if (own(this)) stopChargingStatistics(this) }
  })
}
